import gql from 'graphql-tag'

export default gql`
    mutation createClientMessage($required: ClientMessageInput!) {
        cashAssist {
            createClientMessage(required: $required){
              id  
              isForShop
              body(type: plain)
              hasConfirm
              sender
              subject
              recipientId
              createdAt
            }
        }
    }
`
